import React, { ReactElement } from 'react'
import { ResponsiveContainer, LineChart, Line, Legend, Tooltip, CartesianGrid, XAxis, YAxis } from 'recharts'

export default function GraphComponent(prop: {fetchedCSVData: { time: string, value: number }[] }) : ReactElement {
    const { fetchedCSVData } = prop
    const maxPrRow = fetchedCSVData.map(row => {
        // const value = Math.max(row.value0, row.value1, row.value2, row.value3)
        return row.value
    })
    const max = Math.max(...maxPrRow) + 5

    const minPrRow = fetchedCSVData.map(row => {
        return row.value
    })
    const min = Math.min(...minPrRow) - 5
    // const realMin = min < 0 ? 0 : min
    return (
        <div>
            <ResponsiveContainer width="95%" height={600}>
                <LineChart width={1000} height={600} data={fetchedCSVData} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}>
                    <Line type="monotone" dataKey="value" stroke="green" dot={false} />
                    <CartesianGrid stroke="#ccc" strokeDasharray="5 5" />
                    <XAxis dataKey="time" />[]
                    <Tooltip />
                    <Legend />
                    <YAxis type="number" domain={[min, max]} />
                </LineChart>
            </ResponsiveContainer>
        </div>
    )
}
